module.exports = __webpack_public_path__ + "img/icon-compensation.461ec046.svg";